import { render } from "./completeonBoard.vue?vue&type=template&id=6f1a5b7a&scoped=true&ts=true"
import script from "./completeonBoard.vue?vue&type=script&lang=ts"
export * from "./completeonBoard.vue?vue&type=script&lang=ts"

import "./completeonBoard.vue?vue&type=style&index=0&id=6f1a5b7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1a5b7a"]])

export default __exports__